import { Schema, SchemaValidationError, StringValue, RecordValue, ArrayValue, } from '@coveo/bueno';
export const requiredNonEmptyString = new StringValue({
    required: true,
    emptyAllowed: false,
});
export const nonEmptyString = new StringValue({
    required: false,
    emptyAllowed: false,
});
export const requiredEmptyAllowedString = new StringValue({
    required: true,
    emptyAllowed: true,
});
export const nonRequiredEmptyAllowedString = new StringValue({
    required: false,
    emptyAllowed: true,
});
export const nonEmptyStringArray = new ArrayValue({
    each: requiredNonEmptyString,
    required: true,
});
export const optionalNonEmptyVersionString = new StringValue({
    required: false,
    emptyAllowed: false,
    regex: /^\d+\.\d+\.\d+$/,
});
export const optionalTrackingId = new StringValue({
    required: false,
    emptyAllowed: false,
    regex: /^[a-zA-Z0-9_\-.]{1,100}$/,
});
export const requiredTrackingId = new StringValue({
    required: true,
    emptyAllowed: false,
    regex: /^[a-zA-Z0-9_\-.]{1,100}$/,
});
export const serializeSchemaValidationError = ({ message, name, stack, }) => ({ message, name, stack });
/**
 * Validates an action payload and throws an error if invalid
 * @param payload the action payload
 * @param definition Either a Bueno SchemaDefinition or a SchemaValue
 */
export const validatePayloadAndThrow = (payload, definition) => {
    const isSchemaValue = 'required' in definition;
    if (isSchemaValue) {
        return {
            payload: new Schema({
                value: definition,
            }).validate({ value: payload }).value,
        };
    }
    const asRecordValue = new RecordValue({
        options: { required: true },
        values: definition,
    });
    const isInvalid = asRecordValue.validate(payload);
    if (isInvalid) {
        throw new SchemaValidationError(isInvalid);
    }
    return { payload };
};
/**
 * Validates an action payload and return an `error` alongside the payload if it's invalid
 * @param payload the action payload
 * @param definition Either a Bueno SchemaDefinition or a SchemaValue
 */
export const validatePayload = (payload, definition) => {
    try {
        return validatePayloadAndThrow(payload, definition);
    }
    catch (error) {
        return {
            payload,
            error: serializeSchemaValidationError(error),
        };
    }
};
export const validateInitialState = (engine, schema, obj, functionName) => {
    const message = `Check the initialState of ${functionName}`;
    return validateObject(engine, schema, obj, message, 'Controller initialization error');
};
export const validateOptions = (engine, schema, obj, functionName) => {
    const message = `Check the options of ${functionName}`;
    return validateObject(engine, schema, obj, message, 'Controller initialization error');
};
const validateObject = (engine, schema, obj, validationMessage, errorMessage) => {
    try {
        return schema.validate(obj, validationMessage);
    }
    catch (error) {
        engine.logger.error(error, errorMessage);
        throw error;
    }
};
